import SpreeAPIOrderAdapter from './ams-adapters/spree-api-order-adapter';
import APP_DEFAULTS from '../constants/app-defaults';

const request = require('superagent');

const OrdersAPI = {
    create: (locale, userToken, fpInfo = null, municipality = undefined) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = locale;
        if (municipality) {
            sanitizedQueryParams.municipality = municipality;
        }
        const get = request
            .post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/cart`)
            .query(sanitizedQueryParams);

        if (userToken) {
            get.set('authorization', `Bearer ${userToken}`);
        }

        const fpPayload = {};
        // transforming fingerprint info to the expected api format
        if (fpInfo) {
            fpPayload.sign = {
                requestId: fpInfo.requestId,
                visitorId: fpInfo.visitorId,
                visitorFound: fpInfo.visitorFound,
                confidence: fpInfo.confidence.score,
                incognito: fpInfo.incognito,
                ip: fpInfo.ip || '',
                latitude: (fpInfo.ipLocation && fpInfo.ipLocation.latitude) ? fpInfo.ipLocation.latitude : '',
                longitude: (fpInfo.ipLocation && fpInfo.ipLocation.longitude) ? fpInfo.ipLocation.longitude : '',
                postalCode: (fpInfo.ipLocation && fpInfo.ipLocation.postalCode) ? fpInfo.ipLocation.postalCode : '',
                timeZone: (fpInfo.ipLocation && fpInfo.ipLocation.timezone) ? fpInfo.ipLocation.timezone : '',
                city: (fpInfo.ipLocation && fpInfo.ipLocation.city && fpInfo.ipLocation.city.name) ? fpInfo.ipLocation.city.name : '',
                continent: (fpInfo.ipLocation && fpInfo.ipLocation.continent && fpInfo.ipLocation.continent.name) ? fpInfo.ipLocation.continent.name : '',
                country: (fpInfo.ipLocation && fpInfo.ipLocation.country && fpInfo.ipLocation.country.name) ? fpInfo.ipLocation.country.name : '',
                state: (fpInfo.ipLocation && fpInfo.ipLocation.subdivisions && fpInfo.ipLocation.subdivisions[0]) ? fpInfo.ipLocation.subdivisions[0].name : '',
                browserName: fpInfo.browserName || '',
                browserVersion: fpInfo.browserVersion || '',
                osName: fpInfo.os || '',
                osVersion: fpInfo.osVersion || '',
                device: fpInfo.device || '',
                botProbability: (fpInfo.bot && fpInfo.bot.probability) ? fpInfo.bot.probability : '',
                botSaf: (fpInfo.bot && fpInfo.bot.safe) ? fpInfo.bot.safe : '',
            };
        }

        return get.send(fpPayload);
    },

    destroy: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;

        return request
            .patch(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/cart/empty`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams);
    },

    get: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;
        sanitizedQueryParams.zone_id = params.currentZone;

        return request
            // eslint-disable-next-line max-len
            .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/cart?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types,municipality,municipality.state`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .send()
            .then((response) => {
                response.body = SpreeAPIOrderAdapter.processItem(response.body);

                return response;
            });
    },

    getByUser: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;
        sanitizedQueryParams.zone_id = params.currentZone;

        return request
            // eslint-disable-next-line max-len
            .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/cart?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types,municipality,municipality.state`)
            .set('Authorization', `Bearer ${params.token}`)
            .set('Content-Type', 'application/vnd.api+json')
            // if params.orderToken is undefined header isn't added to the request.
            .set('X-Spree-Order-Token', params.orderToken)
            .query(sanitizedQueryParams)
            .send()
            .then((response) => {
                response.body = SpreeAPIOrderAdapter.processItem(response.body);

                return response;
            });
    },

    mine: (userToken, params = {}) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;
        sanitizedQueryParams.page = params.page_no || 1;
        sanitizedQueryParams.per_page = APP_DEFAULTS.ordersPerPage;
        sanitizedQueryParams.sort = '-completed_at';

        // eslint-disable-next-line max-len
        return request
            .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}`
                + '/api/v2/storefront/account/orders'
                + '?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,'
                + 'promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types')
            .query(sanitizedQueryParams)
            .set('authorization', `Bearer ${userToken}`)
            .set('Accept', 'application/json')
            .send()
            .then((response) => {
                response.body = SpreeAPIOrderAdapter.processList(response.body);

                return response;
            });
    },
};

export default OrdersAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/order.js
 **/